import React from 'react';
import { Caption } from '~/shared/Typography';
import { useAppNavigate } from '~/pages';
import { useHomePageStyles } from '~/shared/styles';
import { Pressable } from 'native-base';
import { i18nFn, I18nReacher } from '@springbig/shared';

type CardBottomLinkProps = {
    t: i18nFn,
    link?: string,
    text: I18nReacher,
    onClick?: () => void;
    button?: 'primary' | 'secondary';
};

export const CardBottomLink = ({
    t,
    link,
    text,
    onClick,
    button,
}: CardBottomLinkProps) => {

    const { navigate, params } = useAppNavigate();
    const {
        pressable_text,
        primary_color,
        button_background,
        button_text
    } = useHomePageStyles();

    const _bgColors = {
        primary: button_background,
        secondary: primary_color,
    };

    const _fontWeight = button ? 300 : 400;
    const _borderWidth = button === 'secondary' ? 2 : 0;
    const _bg = _bgColors[button];
    const _text = button === 'primary' ? button_text : pressable_text;
    const _py = button === 'primary' ? 2 : 0;
    const _px = button === 'primary' ? 4 : 2;

    return (
        <Pressable
            onPress={
                link ?
                    () => navigate(`w/${params.wallet_id}/${link}`)
                    :
                    () => onClick()
            }
            bg={_bg}
            rounded={'md'}
            alignSelf={'center'}
        >
            <Caption
                color={_text}
                fontSize={16}
                fontWeight={_fontWeight}
                textAlign={'center'}
                borderWidth={_borderWidth}
                borderColor={pressable_text}
                rounded={'xl'}
                py={_py}
                px={_px}
            >
                { t(`${text}`) }
            </Caption>
        </Pressable>
    );
};
